import FourOFourPage from './404';

const state = {
  	name: '404',
  	url: '/404',
  	component: FourOFourPage
};

export default state;